<script>
import api from "@services/api";
import Layout from "@layouts/main-fluid";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import ExpandableTextLine from "vue-expandable-text-line";
import DateRangePicker from "vue2-daterange-picker";
import dateRangePickerConfig from "@configs/dateRangePickerConfig";

export default {
  name: "TarefaDetalhe",
  page: {
    title: "Tarefa Detalhe"
  },
  components: {
    Layout,
    ExpandableTextLine,
    DateRangePicker
  },
  props: {
    exibeFiltros: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    showModalDelete: false,
    selectedConsultor: null,
    selectedBusca: null,
    title: "Tarefa Detalhe",
    timelineKey: 0,
    itemsExpediente: null,
    gerandoResumoIa: false,
    erroResumoIa: "",
    showModalResumoCronologico: false,
    resumoCronologico: null,
    items: [
      {
        text: "Página inicial",
        href: "/"
      },
      {
        text: "Tarefa Detalhe",
        active: true
      }
    ],
    item: {
      usuario: { nome: "" }
    },
    tarefaId: null,
    hasItems: false,
    customRanges: dateRangePickerConfig.customRanges,
    maxDate: dateRangePickerConfig.maxDate(),
    localeData: dateRangePickerConfig.localeData,
    dateRange: {
      startDate: new Date().setHours(0, 0, 0),
      endDate: new Date().setHours(0, 0, 0)
    }
  }),
  methods: {
    get(id) {
      api.get(`api/Tarefa/TarefaResumo/${id}`).then(response => {
        this.item = response.data["data"];
        this.loadedUpdate = true;
        this.tarefaId = id;
        this.getData();
      });
    },
    updateRange() {
      this.getData();
    },

    editTarefa() {
      if (this.user.perfil === "Administrador") {
        this.$router.push(
          this.$route.query.redirectFrom || {
            path: `/Tarefa/Edicao/${this.item.id}`
          }
        );
      }
    },
    hasHistory() {
      return window.history.length > 2;
    },
    removeTarefa() {
      this.showModalDelete = true;
    },
    cancelRemove() {
      this.showModalDelete = false;
    },
    confirmRemove() {
      if (this.item.id) {
        api.delete(`api/Tarefa/${this.item.id}`).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.back();
          }
        });
        this.selectedId = null;
        this.showModalDelete = false;
      }
    },
    getData() {
      api
        .get(`api/Tarefa/GetExpedientesTarefa`, {
          params: {
            tarefaId: this.tarefaId,
            dataInicial: this.dateRange.startDate,
            dataFinal: this.dateRange.endDate,
            consultoresId: this.selectedConsultor,
            busca: this.selectedBusca
          }
        })
        .then(response => {
          this.itemsExpediente = this.groupBy(response.data["data"], "data");

          if (
            response.data["data"] !== null &&
            response.data["data"].length > 0
          ) {
            this.hasItems = true;
          } else {
            this.hasItems = false;
          }
        });
    },
    async obterResumoCronologicoIa() {
      if (!this.tarefaId) return;

      this.gerandoResumoIa = true;
      this.erroResumoIa = "";
      try {
        const response = await api.post(
          "crud/Expediente/resumo-cronologico-ia",
          {
            tarefaId: this.tarefaId,
            tarefa: this.item.denominacao,
            cliente: this.item.cliente
          }
        );

        if (
          response &&
          response.data &&
          response.data.status.toLowerCase() === "success"
        ) {
          this.resumoCronologico = response.data.data;
          this.showModalResumoCronologico = true;
        } else {
          this.erroResumoIa =
            (response && response.data && response.data.message) ||
            "Não foi possível gerar o resumo com IA no momento. Tente novamente.";
        }
      } catch (error) {
        this.erroResumoIa =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Não foi possível conectar ao serviço de IA para gerar o resumo. Tente novamente em instantes.";
      } finally {
        this.gerandoResumoIa = false;
      }
    },
    callDetails(id) {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Expediente/Detalhes/${id}`
        }
      );
    },
    callCopy(id) {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Expediente/Copiar/${id}`
        }
      );
    },
    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    back() {
      if (this.hasHistory()) {
        this.$router.go(-1);
      } else {
        this.$router.push(
          this.$route.query.redirectFrom || {
            path: `/Tarefas`
          }
        );
      }
    }
  },
  created() {
    this.tarefaId = parseInt(this.$route.params.id);

    let endDate = new Date();
    endDate.setHours(0, 0, 0, 0);

    let startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
    startDate.setHours(0, 0, 0);
    this.dateRange = {
      startDate: startDate,
      endDate: endDate
    };

    this.get(this.tarefaId);
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    filters() {
      return this.$store.state.filter.filters;
    }
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title">{{ item.denominacao }}</h4>
            <p class="sub-header">
              {{ item.cliente }}
            </p>

            <div class="row">
              <div class="col-md-3">
                <p class="mt-2 mb-1 text-muted">Contrato</p>
                <div class="media">
                  <i class="fe-file-text font-18 text-success mr-2"></i>
                  <div class="media-body">
                    <h5 class="mt-1 font-14">
                      {{ item.contrato }}
                    </h5>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <p class="mt-2 mb-1 text-muted">Responsável</p>
                <div class="media">
                  <i class="fe-user font-18 text-success mr-2"></i>
                  <div class="media-body">
                    <h5 class="mt-1 font-14">
                      {{ item.responsavel }}
                    </h5>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <p class="mt-2 mb-1 text-muted">Status</p>
                <div class="media">
                  <i class="fe-activity font-18 text-success mr-2"></i>
                  <div class="media-body">
                    <h5 class="mt-1 font-14">
                      {{ item.status }}
                    </h5>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <p class="mt-2 mb-1 text-muted">Total de Horas</p>
                <div class="media">
                  <i class="fe-clock font-18 text-success mr-2"></i>
                  <div class="media-body">
                    <h5 class="mt-1 font-14">
                      {{ item.chRealizado }} / {{ item.chPrevisto }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body row">
            <div class="col-md-6">
              <date-range-picker
                ref="picker"
                opens="right"
                :locale-data="localeData"
                :singleDatePicker="false"
                :timePicker="false"
                :timePicker24Hour="false"
                :showWeekNumbers="false"
                :showDropdowns="true"
                :autoApply="true"
                v-model="dateRange"
                :ranges="customRanges"
                @update="updateRange"
                :linkedCalendars="true"
              >
                <template v-slot:input="picker" style="min-width: 350px">
                  {{ picker.startDate | formatField("date") }} -
                  {{ picker.endDate | formatField("date") }}
                </template>
              </date-range-picker>
            </div>
            <div
              class="col-md-6 d-flex justify-content-end align-items-center"
              v-if="
                user.perfil === 'Administrador' || user.perfil === 'Consultor'
              "
            >
              <b-button
                variant="outline-info"
                class="btn ml-2"
                :disabled="gerandoResumoIa"
                @click="obterResumoCronologicoIa"
                title="Gera um resumo executivo dos últimos 20 lançamentos"
              >
                <span v-if="gerandoResumoIa" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                <i v-else class="fa fa-bar-chart mr-1"></i>
                Resumo da IA
              </b-button>
              <b-button variant="light" class="btn ml-2" v-on:click="back()">
                Voltar
              </b-button>
              <b-button
                variant="primary"
                class="btn ml-2"
                v-on:click="editTarefa()"
                v-if="user.perfil == 'Administrador'"
                >Editar</b-button
              >
              <b-button
                variant="danger"
                class="btn ml-2"
                v-on:click="removeTarefa()"
              >
                Remover
              </b-button>
            </div>
          </div>

          <b-alert
            v-if="erroResumoIa"
            show
            variant="warning"
            dismissible
            @dismissed="erroResumoIa = ''"
            class="my-2 mx-1"
          >
            <i class="fa fa-exclamation-triangle mr-1"></i> <strong>Atenção:</strong> {{ erroResumoIa }}
          </b-alert>

          <div class="row mt-3 mb-3 ml-2" v-show="!hasItems">
            Não foram encontrados registros.
          </div>

          <div
            v-show="hasItems"
            v-for="(expedientes, key) in itemsExpediente"
            :key="key"
            class="m-1 mt-2 row card expedientes-card"
          >
            <div class="card-body expedientes-lista">
              <h5 class="card-title">
                {{ key | formatField("extdate") }}
                <span class="float-right mr-2">
                  {{ expedientes[0].duracaoDia }}
                </span>
              </h5>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead></thead>
                  <tbody>
                    <tr
                      v-for="expediente in expedientes"
                      :key="expediente.id"
                      :class="
                        `${
                          !expediente.isExpedienteConsultor ? 'linestrip' : ''
                        }`
                      "
                    >
                      <td>
                        <div class="expediente-tags">
                          <span class="badge badge-pill badge-dark mr-1">
                            {{ expediente.consultor }}
                          </span>
                          <span
                            v-for="tag in expediente.tags.split(',')"
                            :key="tag"
                            class="badge badge-pill badge-primary mr-1"
                            >{{ tag }}</span
                          >
                        </div>
                        <div class="long-text">
                          <expandable-text-line
                            use-click
                            class="unprinting"
                            :duration="0"
                            v-text="expediente.descricao"
                          />
                          <div class="print-content">
                            {{ expediente.tarefa }}
                            {{ expediente.descricao }}
                          </div>
                        </div>
                      </td>
                      <td width="120px;" class="text-center">
                        {{ expediente.periodo }}
                      </td>
                      <td width="80px;" class="text-center">
                        {{ expediente.duracaoExpediente }}
                      </td>
                      <td
                        width="140px;"
                        v-if="
                          user.perfil === 'Administrador' ||
                            user.perfil === 'Consultor'
                        "
                      >
                        <div class="float-right">
                          <b-button
                            class="btn btn-sm btn-icon"
                            variant="primary"
                            v-on:click="callDetails(expediente.id)"
                            ><i class="fe-more-horizontal"
                          /></b-button>
                          <b-button
                            class="btn btn-sm ml-1 btn-icon"
                            variant="primary"
                            v-on:click="callCopy(expediente.id)"
                            ><i class="fe-copy"
                          /></b-button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Resumo Cronológico da IA (Top 20) -->
    <b-modal
      v-model="showModalResumoCronologico"
      :title="resumoCronologico ? resumoCronologico.titulo : 'Resumo da IA'"
      size="xl"
      centered
      scrollable
      hide-footer
    >
      <template v-if="resumoCronologico">
        <div class="d-flex flex-wrap align-items-center justify-content-between mb-3 pb-2 border-bottom">
          <div class="text-muted small">
            <span v-if="resumoCronologico.periodo" class="mr-3">
              📅 <strong>Período:</strong> {{ resumoCronologico.periodo }}
            </span>
            <span>
              📋 <strong>Expedientes analisados:</strong> {{ resumoCronologico.totalExpedientesAnalisados }}
            </span>
          </div>
          <b-badge variant="info" pill class="px-3 py-2">
            Síntese Executiva de Avanços
          </b-badge>
        </div>

        <div class="card mb-4 bg-light border-0 shadow-sm">
          <div class="card-body">
            <h6 class="text-primary font-weight-bold mb-2">
              <i class="fa fa-file-text-o mr-1"></i> Resumo Executivo da Evolução
            </h6>
            <p class="mb-0 text-dark" style="white-space: pre-line; line-height: 1.6;">
              {{ resumoCronologico.resumoExecutivo }}
            </p>
          </div>
        </div>

        <div v-if="resumoCronologico.fasesOuEtapas && resumoCronologico.fasesOuEtapas.length" class="mb-4">
          <h6 class="font-weight-bold mb-3">
            <i class="fa fa-tasks mr-1 text-primary"></i> Linha do Tempo e Etapas Desenvolvidas
          </h6>
          <div class="timeline-container">
            <div
              v-for="(fase, idx) in resumoCronologico.fasesOuEtapas"
              :key="idx"
              class="timeline-item mb-3"
            >
              <div class="timeline-badge bg-primary text-white font-weight-bold">
                {{ idx + 1 }}
              </div>
              <div class="timeline-content p-3 border rounded shadow-sm bg-white">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <strong class="text-dark">{{ fase.fase }}</strong>
                  <b-badge v-if="fase.periodo" variant="light" class="border text-secondary">
                    {{ fase.periodo }}
                  </b-badge>
                </div>
                <ul class="mb-0 pl-3 small text-muted">
                  <li v-for="(ativ, aIdx) in fase.atividadesPrincipais" :key="aIdx">
                    {{ ativ }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="card h-100 border-success shadow-sm">
              <div class="card-header bg-success text-white py-2 font-weight-bold">
                <i class="fa fa-check-circle mr-1"></i> Principais Entregas Consolidadas
              </div>
              <div class="card-body py-2">
                <ul class="mb-0 pl-3 small">
                  <li v-for="(entrega, idx) in resumoCronologico.principaisEntregas" :key="idx" class="mb-1">
                    {{ entrega }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="card h-100 border-info shadow-sm">
              <div class="card-header bg-info text-white py-2 font-weight-bold">
                <i class="fa fa-arrow-circle-right mr-1"></i> Próximos Passos e Pendências
              </div>
              <div class="card-body py-2">
                <ul class="mb-0 pl-3 small">
                  <li v-for="(passo, idx) in resumoCronologico.proximosPassosOuPendencias" :key="idx" class="mb-1">
                    {{ passo }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3 pt-2 border-top">
          <b-button variant="primary" @click="showModalResumoCronologico = false">
            Fechar
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
.timeline-container {
  position: relative;
  padding-left: 20px;
  border-left: 2px solid #dee2e6;
  margin-left: 14px;
}

.timeline-item {
  position: relative;
}

.timeline-badge {
  position: absolute;
  left: -32px;
  top: 10px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
}
</style>
